<template>
  <div>
    <label :for="id">{{ label }}</label>
    <select :id="id" v-model="value" :disabled="disabled">
      <option v-if="optionConfig.emptySelectOption" :value="''">{{
        translations[language][NONE]
      }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">{{
        getOptionLabel(option)
      }}</option>
    </select>
  </div>
</template>

<script>
import { advancedOptionToRenderConfig } from '@/utils/advancedOptions'

import { mapGetters } from 'vuex'

import * as translationInput from './input.translations'
const { default: translations, ...translationKeys } = translationInput

export default {
  name: 'SelectInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    advanced_option: {
      required: true,
      type: String,
    },
    question_index: {
      required: true,
      type: Number,
    },
    questions_groups_index: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      translations,
      ...translationKeys,
      optionConfig: null,
      label: '',
      required: false,
    }
  },
  computed: {
    ...mapGetters(['questionGroups']),

    currentQuestionOptions() {
      return this.questionGroups[this.questions_groups_index].questions[
        this.question_index
      ].advancedOptions
    },

    value: {
      get() {
        return (
          this.questionGroups[this.questions_groups_index].questions[this.question_index]
            .advancedOptions[this.advanced_option] || ''
        )
      },
      set(value) {
        this.$store.dispatch('changeAdvanced', {
          questionGroupIndex: this.questions_groups_index,
          questionIndex: this.question_index,
          advancedKey: this.advanced_option,
          value: value === '' ? null : value,
        })
      },
    },

    options() {
      return this.optionConfig
        ? this.optionConfig.options ||
            this.optionConfig.optionsGetter(
              this.questionGroups[this.questions_groups_index].questions,
              this.question_index,
              this.questionGroups.slice(0, this.questions_groups_index),
              this.currentQuestionOptions,
            )
        : []
    },

    disabled() {
      const currentOptions = this.questionGroups[this.questions_groups_index].questions[
        this.question_index
      ].advancedOptions

      const isDisabled = this?.optionConfig.disableChecker?.(currentOptions)

      return isDisabled
    },
  },

  watch: {
    language() {
      this.label = this.optionConfig.displayText[this.language]
    },
  },

  methods: {
    getOptionLabel(option) {
      return option.label?.[this.language] || option.label
    },
  },

  created() {
    this.optionConfig = advancedOptionToRenderConfig[this.advanced_option]
    this.label = this.optionConfig.displayText[this.language]
    this.required = this.optionConfig.required
  },
}
</script>

<style scoped lang="scss">
div {
  display: flex;
  align-items: center;

  label {
    width: fit-content;
    white-space: nowrap;
    user-select: none;
    color: $gray-10;
    @include tipography(16);
  }

  select {
    border-radius: 4px;
    padding: 5px 10px;
    outline: none;
    margin-left: 15px;
    background: $main-3;
    color: $white;
    &:focus {
      border: 1px solid $main;
    }
  }

  .light & {
    label {
      color: $main;
    }

    select {
      background: $white;
      color: $gray-6;
    }
  }
}
</style>
